import { Component, OnInit } from '@angular/core'
import { NotificationStatus } from 'src/app/shared/enums/notification-tabs.enum'
import { Subscription } from 'rxjs'
import { NotificationService } from '../../services/notifications.service'
import { Notification, notificationsFilter } from '../../models/notification'

@Component({
	selector: 'app-notification-list',
	templateUrl: './notification-list.component.html',
	styleUrls: ['./notification-list.component.scss'],
})
export class NotificationListComponent implements OnInit {
	subscriptions = new Subscription()
	NotificationStatus = NotificationStatus
	totalCount = 0
	notifications: Notification[] = []
	NotificationFilter: notificationsFilter = {
		Paging: { PageNumber: 1, PageSize: 10 },
		IsRead: '',
		NotificationTap: 0,
	}
	constructor(
		private notificationsService: NotificationService,

	) { }

	ngOnInit(): void {
		this.subscriptions.add(
			this.notificationsService.messageReceivingSubject.subscribe({
				next: (message: any) => {
					this.NotificationFilter?.NotificationTap == 0 ||
						this.NotificationFilter?.NotificationTap == message?.data?.notificationType ?
						this.notifications.unshift(message?.data) : null
				},
			})
		)
		this.getNotifications()
	}

	getNotifications(isScroll: boolean = false) {
		this.subscriptions.add(
			this.notificationsService
				.getNotificationList(
					this.NotificationFilter
				)
				.subscribe((res: any) => {
					isScroll ? this.notifications.push(...res.result?.items) : (this.notifications = res.result?.items)
					this.totalCount = res?.result?.totalCount
				})
		)
	}
	onScrollDown(event: any) {
		if (this.totalCount > this.notifications?.length && document.body.offsetHeight - 500 <= event?.currentScrollPosition) {
			this.NotificationFilter.Paging.PageNumber++;
			this.getNotifications(true)
		}

	}

	ngOnDestroy(): void {
		this.subscriptions.unsubscribe()
	}
}
